<template>
  <v-parallax class="hero" src="/img/lymphatic/hero.webp" alt="Lymphatic drainage massage therapy">
    <div class="hero-banner fill-height d-flex flex-column justify-center">
      <div class="intro-text d-flex flex-column justify-center pt-0 pa-8">
        <div class="text-center text-subtitle-1 pa-2">You are one step away from</div>
        <div class="text-center text-h2 pa-2">revitalized well-being</div>
      </div>
      <div class="text-center">
        <v-btn class="book-now-button" color="primary" size="large" :href="$bookingUrls.LymphaticDrainage.Default">Book now!</v-btn>
      </div>
    </div>
  </v-parallax>

  <section id="why-choose">
    <div class="full-width-header">Why choose our lymphatic drainage?</div>
    <div class="content pb-16">
      <div class="feature-grid">
        <div class="feature-item" v-for="item in whyChoose" :key="item.title">
          <div class="feature-title">{{ item.title }}</div>
          <div class="feature-text">{{ item.description }}</div>
        </div>
      </div>

      <div class="text-center">
        <v-btn class="book-now-button" color="primary" size="large" :href="$bookingUrls.LymphaticDrainage.Default">Book now!</v-btn>
      </div>
    </div>
  </section>

  <section id="why-choose">
    <div class="full-width-header">Trusted by our clients</div>
    <div class="content pb-16">
      <div class="quote-block" v-for="review in featureReviews" :key="review.name">
        <img class="quote-stars" :src="starsImage" alt="Five stars" />
        <p class="quote-text">"{{ review.quote }}"</p>
        <div class="quote-author">{{ review.name }}</div>
      </div>

      <div class="text-center">
        <v-btn class="book-now-button" color="primary" size="large" :href="$bookingUrls.LymphaticDrainage.Default">Book now!</v-btn>
      </div>
    </div>
  </section>

  <BenefitsSectionComponent
    header="What are the benefits of Lymphatic Drainage?"
    :benefits="benefits"
    :booking-url="$bookingUrls.LymphaticDrainage.Default" />

  <section id="pricing">
    <div class="full-width-header">Individual Sessions & Packages</div>
    <div class="content pb-16">
      <p class="content-intro">
        Choose between our convenient package options or flexible individual sessions. Book now to experience the
        transformative effects of lymphatic drainage and make the most of your wellness journey!
      </p>

      <div class="service-list d-flex flex-wrap justify-center ga-12 px-8">
        <ServiceItemComponent
          title="5-Session Packages"
          :booking-options="packageOptions"
          :link-target="'_self'"
          class="service-item-card" />
        
        <ServiceItemComponent
          title="Individual Sessions"
          :booking-options="sessionOptions"
          :link-target="'_self'"
          class="service-item-card" />
      </div>
    </div>
  </section>

  <section id="cta">
    <div class="full-width-header">Ready to feel rejuvenated?</div>
    <div class="content pb-16">
      <p class="content-intro">
        Take the first step towards better health and well-being. Book your lymphatic drainage session today.
      </p>
      <div class="text-center">
        <v-btn class="book-now-button" color="primary" size="large" :href="$bookingUrls.LymphaticDrainage.Default">Book now!</v-btn>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { BookingUrls } from '@/constants/booking';
import BookingOption from '@/models/BookingOption';
import BenefitsSectionComponent from '@/components/BenefitsSectionComponent.vue';
import ServiceItemComponent from '@/components/ServiceItemComponent.vue';

export default defineComponent({
  name: 'LymphaticDrainageView',

  components: {
    BenefitsSectionComponent,
    ServiceItemComponent
  },

  data() {
    return {
      whyChoose: [
        {
          title: 'Certified Expertise',
          description: 'Trained in specialized lymphatic drainage techniques with years of proven results for clients.'
        },
        {
          title: 'Holistic Approach',
          description: 'We assess your unique needs and create a tailored treatment plan that evolves with your progress.'
        },
        {
          title: 'Trusted by Healthcare Professionals',
          description: 'Recommended for pre and post-operative care, supporting your body\'s natural healing and recovery.'
        }
      ],
      benefits: [
        {
          title: 'Reduces Swelling',
          description: 'Especially beneficial for post-surgery healing and overall wellness.'
        },
        {
          title: 'Boosts Immune System',
          description: 'Improves lymphatic flow to support your body’s natural defenses.'
        },
        {
          title: 'Promotes Relaxation',
          description: 'A gentle treatment that calms the mind and soothes the body.'
        }
      ],
      starsImage: '/img/five-stars.png',
      packageOptions: [
        new BookingOption('5 x 50 min', BookingUrls.LymphaticDrainage.Package50),
        new BookingOption('5 x 1h 15min', BookingUrls.LymphaticDrainage.Package80)
      ],
      sessionOptions: [
        new BookingOption('50 min', BookingUrls.LymphaticDrainage.Min50),
        new BookingOption('1h 15min', BookingUrls.LymphaticDrainage.Min80)
      ],
      featureReviews: [
        {
          name: "Jessica T",
          quote:
            "I am seeing jasmine for post surgery lymphatic drainage massages and she is amazing at what she does, the instant relief afterwards is great. Highly recommend."
        },
        {
          name: "Niamh O'Brien",
          quote:
            "Jasmine is a very gifted therapist. Her lymphatic drainage massage is extremely relaxing but also highly effective at reducing water retention. She's a lovely, kind person and I couldn't recommend her highly enough."
        }
      ]
    };
  }
});
</script>